export default function SectionHeader({ eyebrow, title, kicker, align = "left" }) {
    const alignment = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-3xl ${alignment}`}>
            {eyebrow && (
                <div className="text-[10px] tracking-[0.3em] uppercase text-brand-red mb-4 inline-flex items-center gap-2">
                    <span className="inline-block w-8 h-px bg-brand-red" />
                    {eyebrow}
                </div>
            )}
            <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white leading-[0.95]">
                {title}
            </h2>
            {kicker && <p className="mt-5 text-zinc-200 text-base md:text-lg leading-relaxed">{kicker}</p>}
        </div>
    );
}
